import * as React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { motion } from "framer-motion";
import { loginSchema } from "../../schema/loginSchema";
import toast from "react-hot-toast";
import { Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import AuthLayout from "../../components/auth/AuthLayout";
import StylishInput from "../../components/auth/StylishInput";
import { useAuth } from "../../hooks/useAuth";

const LoginPage = () => {
  const { login, isLoading } = useAuth();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      await login([data]);
      toast.success("Successfully logged in.");
      navigate("/Product_All");
    } catch (error) {
      toast.error("An error occurred. Please try again");
      console.log("error: ", error);
    }
  };

  return (
    <AuthLayout title="Login">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <StylishInput
          label="Username"
          type="text"
          // because this is what the name is in the API
          register={register("login")}
          error={errors.login}
        />
        <StylishInput
          label="Password"
          type="password"
          register={register("password")}
          error={errors.password}
        />
        <motion.button
          whileHover={{ scale: 0.99 }}
          whileTap={{ scale: 0.98 }}
          type="submit"
          className="w-full bg-indigo-600 text-white rounded-lg py-3 font-medium hover:bg-indigo-700 transition shadow-lg"
        >
          {isLoading ? (
            <Loader2 className="w-5 h-5 animate-spin mx-auto" />
          ) : (
            "Login"
          )}
        </motion.button>
      </form>
    </AuthLayout>
  );
};

export default LoginPage;
